import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { Link } from "react_reusable_components";
import { TwoRow } from "../../core/layouts";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import AddUserManagementFormContainer from "../../containers/AddUserManagementFormContainer";
import variables from "../../themes/base/styles/variables";
import ViewUserDetailsContainer from "../../containers/ViewUserDetailsContainer";

export const AddUserManagementStyle = {
  wrapperStyle: {
    backgroundColor: variables.grey5,
    padding: variables.paddingMedium,
    paddingTop: variables.paddingSmallLG,
  },
  bottomSectionStyle: {
    backgroundColor: variables.bodyBg,
    border: `1px solid ${variables.grey4}`,
    overflow: "hidden",
    height: `calc(100vh - 11.5rem)`,
  },
  topSectionStyle: {
    paddingBottom: `${variables.paddingMedium}`,
  },
};

export default function AddUserManagementView() {
  const intl = useIntl();
  const navigate = useNavigate();
  const { id } = useParams();

  const [mode, setMode] = useState();
  const [labelText, setLabelText] = useState("userManagement.addNewUser");

  useEffect(() => {
    if (!id) {
      setMode("add");
      setLabelText("userManagement.addNewUser");
    } else {
      setMode(window.location.href.includes("view") ? "view" : "edit");
      setLabelText(
        window.location.href.includes("view")
          ? "userManagement.viewUserDetails"
          : "userManagement.editUser"
      );
    }
  }, [id]);

  return (
    <TwoRow
      style={AddUserManagementStyle.wrapperStyle}
      topSectionStyle={AddUserManagementStyle.topSectionStyle}
      topSection={
        <Link
          onClick={(e) => {
            e.preventDefault();
            navigate("/users");
          }}
          type="backNavigation"
          iconSrc={"/icons/arrow_back.svg"}
          labelText={getLocalizedMessage(intl, labelText)}
        />
      }
      bottomSectionStyle={AddUserManagementStyle.bottomSectionStyle}
      bottomSection={
        mode === "view" ? (
          <ViewUserDetailsContainer />
        ) : (
          (mode === "add" || mode === "edit") && (
            <AddUserManagementFormContainer isEditMode={mode === "edit"} />
          )
        )
      }
    />
  );
}
